module.exports = __webpack_public_path__ + "img/vehicle_menu_hover.831fe25a.svg";